import React from 'react';
import { motion } from 'framer-motion';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { animationValues, transitionValues } from '../../utils/pageTransitions';
import NewOrders from './orders/newOrders';
import PendingOrders from './orders/pendingOrders';
import DeliveredOrders from './orders/deliveredOrders';
import ProcessingOrders from './orders/processingOrders';
import CancelledOrders from './orders/cancelledOrders';

function Orders() {


    return (

        <motion.div
            initial='out'
            animate='in'
            exit='out'
            variants={ animationValues }
            transition={ transitionValues }>

            <div className="container-fluid suppliers">


                <div className="">
                    <h2 className="sectionText--big textIsBold">Orders</h2>
                </div>

                <Tabs className='pt-3'>
                    <TabList className='alignOnly sectionText p-0'>
                        {/* <Tab className='tabHead'>New Orders</Tab> */}
                        <Tab className='tabHead'>Proccesing</Tab>
                        <Tab className='tabHead'>Pending</Tab>
                        <Tab className='tabHead'>Delivered</Tab>
                        <Tab className='tabHead'>Cancelled</Tab>
                    </TabList>

                    {/* <TabPanel>
                        <NewOrders/>
                    </TabPanel> */}
                    <TabPanel>
                        <ProcessingOrders/>
                    </TabPanel>
                    <TabPanel>
                        <PendingOrders/>
                    </TabPanel>
                    <TabPanel>
                        <DeliveredOrders/>
                    </TabPanel>
                    <TabPanel>
                        <CancelledOrders />
                    </TabPanel>
                </Tabs>

            </div>

        </motion.div>
    )
}

export default Orders
